import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const CloseIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 12 12" },
        React.createElement("path", { d: "M10.5457 0.696744L11.2528 1.40385C11.4481 1.5991 11.4481 1.91571 11.2528 2.11096L7.36372 6.00004L11.2528 9.88913C11.4481 10.0844 11.4481 10.4009 11.2528 10.5962L10.5457 11.3033C10.3505 11.4986 10.0338 11.4986 9.83859 11.3033L5.94951 7.41426L2.06042 11.3033C1.86517 11.4986 1.54856 11.4986 1.35331 11.3033L0.646207 10.5962C0.450918 10.4009 0.45096 10.0844 0.646207 9.88913L4.53529 6.00004L0.646207 2.11096C0.45096 1.91571 0.45096 1.5991 0.646207 1.40385L1.35331 0.696744C1.5486 0.501455 1.86517 0.501497 2.06042 0.696744L5.94951 4.58583L9.83859 0.696744C10.0338 0.501497 10.3504 0.501455 10.5457 0.696744Z" })));
};

export { CloseIcon };
//# sourceMappingURL=CloseIcon.esm.js.map
